// 圖標映射表
// 當新增圖標時，需要在這裡手動導入並註冊

import AdminLogoIcon from '@/assets/icons/admin-logo-icon.svg'
import ApplyOrgTagIcon from '@/assets/icons/apply-org-tag-icon.svg'
import ChartOverlapIcon from '@/assets/icons/chart-overlap-icon.svg'
import CircleInfoIcon from '@/assets/icons/circle-info-icon.svg'
import DefaultOgImgIcon from '@/assets/icons/default-og-img-icon.svg'
import EditIcon from '@/assets/icons/edit-icon.svg'
import GroupUrlLinkIcon from '@/assets/icons/group-url-link-icon.svg'
import LogoIcon from '@/assets/icons/logo-icon.svg'
import OauthGoogleIcon from '@/assets/icons/oauth-google-icon.svg'
import OauthLineIcon from '@/assets/icons/oauth-line-icon.svg'
import SlashIcon from '@/assets/icons/slash-icon.svg'
import TagOverlapIcon from '@/assets/icons/tag-overlap-icon.svg'
import TagSwitchIcon from '@/assets/icons/tag-switch-icon.svg'
import UploadImgIcon from '@/assets/icons/upload-img-icon.svg'

export const iconMap = {
  'group-url-link-icon': GroupUrlLinkIcon,
  'edit-icon': EditIcon,
  'tag-switch-icon': TagSwitchIcon,
  'tag-overlap-icon': TagOverlapIcon,
  'slash-icon': SlashIcon,
  'chart-overlap-icon': ChartOverlapIcon,
  'apply-org-tag-icon': ApplyOrgTagIcon,
  'upload-img-icon': UploadImgIcon,
  'default-og-img-icon': DefaultOgImgIcon,
  'logo-icon': LogoIcon,
  'circle-info-icon': CircleInfoIcon,
  'admin-logo-icon': AdminLogoIcon,
  'oauth-google-icon': OauthGoogleIcon,
  'oauth-line-icon': OauthLineIcon
} as const

export type IconName = keyof typeof iconMap
